"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genProfileImg = void 0;
var react_1 = __importDefault(require("react"));
var ProfileImageInput_1 = require("../../ImageInput/derivedComps/ProfileImageInput");
var genProfileImg = function (_a) {
    var image = _a.image, display = _a.display, invert = _a.invert;
    return (react_1.default.createElement("div", { style: { flex: "0 0 auto", display: 'flex', alignItems: 'start' }, id: "test" },
        react_1.default.createElement(ProfileImageInput_1.ProfileImageInput, { readOnly: true, value: image, imageTitle: display, size: 20, invert: invert })));
};
exports.genProfileImg = genProfileImg;
